const SET_DANH_SACH_QUYEN_NGUOI_DUNG = (state, danhSachQuyenNguoiDung) => {
  state.danhSachQuyenNguoiDung = danhSachQuyenNguoiDung;
};

const SET_DANH_SACH_PHAN_QUYEN_NGUOI_DUNG = (
  state,
  danhSachPhanQuyenNguoiDung
) => {
  state.danhSachPhanQuyenNguoiDung = danhSachPhanQuyenNguoiDung;
};

const SET_DANH_SACH_CHI_TIET_NGUOI_DUNG = (state, danhSachChiTietNguoiDung) => {
  state.danhSachChiTietNguoiDung = danhSachChiTietNguoiDung;
};

export default {
  SET_DANH_SACH_QUYEN_NGUOI_DUNG,
  SET_DANH_SACH_CHI_TIET_NGUOI_DUNG,
  SET_DANH_SACH_PHAN_QUYEN_NGUOI_DUNG,
};
